import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function findBySubtype(sub, subtype, nat) {
  return sub.find((s) => s.subtype === subtype && s.nat === nat);
}

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

const BetTableMuflis = memo(function BetTableMuflis({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  // With a liability on the cell, a locked cell pins its padlock to the TOP
  // (style.css `.suspended.lock-top:before`) so the figure stays readable —
  // same as Teenpatti 20-20 B / Note Number.
  const lockTop = (item) => (Number(exposures?.[item?.nat]) ? ' lock-top' : '');

  const winnerA  = findBySubtype(sub, 'teenmuf', 'Player A');
  const winnerB  = findBySubtype(sub, 'teenmuf', 'Player B');
  const top9A    = findBySubtype(sub, 'top9',    'Top 9 A');
  const top9B    = findBySubtype(sub, 'top9',    'Top 9 B');
  const mbaccA   = findBySubtype(sub, 'mbacc',   'M Baccarat A');
  const mbaccB   = findBySubtype(sub, 'mbacc',   'M Baccarat B');

  // book span hamesha visible — book-black at 0, minus red / plus green (reference)
  function expSpan(name) {
    const v = roundBook(exposures?.[name] ?? 0);
    return <span className={v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black'}>{fmtBook(v)}</span>;
  }

  return (
    <div className="teen1daycasino-container">

      <div className="teen1dayleft">
        <div className="casino-box-row">
          <div className="casino-nation-name no-border casino-bl-box-title">
            <div className="playera text-left">Player A</div>
          </div>
        </div>

        <div className="row row5">
          <div className="col-12 col-md-4">
            <div className="casino-box-row">
              <div className="casino-nation-name"><b>Winner</b></div>
              <div className="casino-bl-box">
                <div
                  className={`back casino-bl-box-item${lockTop(winnerA)}${suspCls(winnerA)}`}
                  onClick={isSusp(winnerA) ? undefined : () => handleBet(winnerA.sid, 'back', winnerA.b, winnerA)}
                >
                  <span className="casino-box-odd">{winnerA?.b || 0}</span>
                  {expSpan('Player A')}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="casino-box-row">
              <div className="casino-nation-name"><b>Top 9</b></div>
              <div className="casino-bl-box">
                <div
                  className={`back casino-bl-box-item${lockTop(top9A)}${suspCls(top9A)}`}
                  onClick={isSusp(top9A) ? undefined : () => handleBet(top9A.sid, 'back', top9A.b, top9A)}
                >
                  <span className="casino-box-odd">A</span>
                  {expSpan('Top 9 A')}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="casino-box-row">
              <div className="casino-nation-name"><b>M Baccarat A</b></div>
              <div className="casino-bl-box">
                <div
                  className={`back casino-bl-box-item${lockTop(mbaccA)}${suspCls(mbaccA)}`}
                  onClick={isSusp(mbaccA) ? undefined : () => handleBet(mbaccA.sid, 'back', mbaccA.b, mbaccA)}
                >
                  <span className="casino-box-odd">{mbaccA?.b || 0}</span>
                  {expSpan('M Baccarat A')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="teen1daycenter"></div>

      <div className="teen1dayright">
        <div className="casino-box-row">
          <div className="casino-nation-name no-border casino-bl-box-title">
            <div className="playerb text-left">Player B</div>
          </div>
        </div>

        <div className="row row5">
          <div className="col-12 col-md-4">
            <div className="casino-box-row">
              <div className="casino-nation-name"><b>Winner</b></div>
              <div className="casino-bl-box">
                <div
                  className={`back casino-bl-box-item${lockTop(winnerB)}${suspCls(winnerB)}`}
                  onClick={isSusp(winnerB) ? undefined : () => handleBet(winnerB.sid, 'back', winnerB.b, winnerB)}
                >
                  <span className="casino-box-odd">{winnerB?.b || 0}</span>
                  {expSpan('Player B')}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="casino-box-row">
              <div className="casino-nation-name"><b>Top 9</b></div>
              <div className="casino-bl-box">
                <div
                  className={`back casino-bl-box-item${lockTop(top9B)}${suspCls(top9B)}`}
                  onClick={isSusp(top9B) ? undefined : () => handleBet(top9B.sid, 'back', top9B.b, top9B)}
                >
                  <span className="casino-box-odd">B</span>
                  {expSpan('Top 9 B')}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="casino-box-row">
              <div className="casino-nation-name"><b>M Baccarat B</b></div>
              <div className="casino-bl-box">
                <div
                  className={`back casino-bl-box-item${lockTop(mbaccB)}${suspCls(mbaccB)}`}
                  onClick={isSusp(mbaccB) ? undefined : () => handleBet(mbaccB.sid, 'back', mbaccB.b, mbaccB)}
                >
                  <span className="casino-box-odd">{mbaccB?.b || 0}</span>
                  {expSpan('M Baccarat B')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
});

export default BetTableMuflis;
